"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserYandex = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var interfaces_1 = require("@dp-instant/interfaces");
var social_1 = require("@dp-instant/social");
var core_1 = require("@dp-instant/core");
var UserYandex = (function (_super) {
    tslib_1.__extends(UserYandex, _super);
    function UserYandex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isNew = false;
        _this.lbRecords = [];
        return _this;
    }
    UserYandex.prototype.getLbRecord = function (lbName) {
        if (lbName === void 0) { lbName = "Scores"; }
        return this.lbRecords.find(function (item) { return item.lb === lbName; });
    };
    UserYandex.prototype.init = function (source, isNew) {
        if (isNew === void 0) { isNew = false; }
        this.rawData = source;
        this._isNew = isNew;
        return this;
    };
    Object.defineProperty(UserYandex.prototype, "id", {
        get: function () {
            return (((this.rawData.getUniqueID && this.rawData.getUniqueID()) ||
                (this.rawData.getID && this.rawData.getID())) + "");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserYandex.prototype, "name", {
        get: function () {
            return this.rawData.getName && this.rawData.getName() + "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserYandex.prototype, "photo", {
        get: function () {
            return this.rawData.getPhoto && this.rawData.getPhoto("large") + "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserYandex.prototype, "scoreSession", {
        get: function () {
            return this._scores.getScore(social_1.ScoreType.SESSION) || 0;
        },
        set: function (value) {
            this._scores.setScoreSession(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserYandex.prototype, "scoreGlobal", {
        get: function () {
            return this._scores.getScore(social_1.ScoreType.GLOBAL) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserYandex.prototype, "scoreContext", {
        get: function () {
            return this._scores.getScore(social_1.ScoreType.CONTEXT) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserYandex.prototype, "scores", {
        get: function () {
            return this._scores;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserYandex.prototype, "isNew", {
        get: function () {
            return this._isNew;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.userScore),
        tslib_1.__metadata("design:type", Object)
    ], UserYandex.prototype, "_scores", void 0);
    UserYandex = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], UserYandex);
    return UserYandex;
}(core_1.EventDispatcher));
exports.UserYandex = UserYandex;
//# sourceMappingURL=UserYandex.js.map